import { Card, Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import ReactQuill from "react-quill-new";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { quillImageHandler } from "../../utility/quilImageHandler";
import CommonQuill from "../../components/editor/CommonQuill";
import HelperService from "../../utility/HelperService";

interface AddIndiaBatteryManufacturingProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  slug: string;
  createdBy: string;
  meta_description: string;
  keywords: string;
};

const AddIndiaBatteryManufacturing = ({
  show,
  handleClose,
  data,
}: AddIndiaBatteryManufacturingProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    trigger,
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);
  const [logo, setLogo] = useState<File | null>(null);
  const [images, setImages] = useState<any[]>([{}]);
  const [value, setValue] = useState("");
  const [mainContent, setMainContent] = useState("");
  const [keyAreas, setKeyAreas] = useState([{ title: "", logo: "" }]);
  const [trustAreas, setTrustAreas] = useState([{ title: "", logo: "" }]);
  const [stackholders, setStackholders] = useState([{ title: "" }]);
  const [fileError, setFileError] = useState<string>("");
  const [buttons, setButtons] = useState([
    { title: "", url: "", highlight: false },
  ]);
  const quillRef = useRef<any>(null);
  const [customErrors, setCustomErrors] = useState<{
    description?: string;
  }>({});
  const [urlErrors, setUrlErrors] = useState<Record<number, string>>({});

  useEffect(() => {
    const storedUser = localStorage.getItem("UserData");
    const userData = storedUser ? JSON.parse(storedUser) : null;
    if (data) {
      reset({
        title: data.title,
        slug: data.slug,
        keywords: data?.keywords,
        createdBy: userData?.fullName || "",
        meta_description: data?.meta_description,
      });
      setLogo(null);
      setValue(data.description);
      setKeyAreas(
        data.key_areas?.length > 0
          ? data.key_areas
          : [{ title: "", logo: null }],
      );
      setTrustAreas(
        data.trust_areas?.length > 0
          ? data.trust_areas
          : [{ title: "", logo: null }],
      );

      setStackholders(
        data.stackholders?.length > 0 ? data.stackholders : [{ title: "" }],
      );
      setButtons(
        data.buttons?.length > 0
          ? data.buttons
          : [{ title: "", url: "", highlight: false }],
      );
    }
  }, [data, show]);
  const isQuillEmpty = (value?: string) => {
    if (!value) return true;

    // remove html tags, &nbsp; and spaces
    const text = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };
  const validateInfoTab = async () => {
    const titleValid = await trigger(["title"]);

    const newErrors: any = {};

    if (isQuillEmpty(value)) {
      newErrors.description = "Description is required";
    }

    setCustomErrors(newErrors);

    // 🔥 IMPORTANT: return actual validity
    return titleValid && !newErrors.description;
  };
  const onSubmit = async (request: FormData) => {
    const valid = await validateInfoTab();
    if (!valid) {
      toast.error("Please fill required fields");
      return;
    }
    setLoading(true);

    const formData = new FormData();

    const storedUser = localStorage.getItem("UserData");
    const userData = storedUser ? JSON.parse(storedUser) : null;

    // 🔥 Basic fields
    formData.append("title", request.title);
    formData.append("slug", request.slug);
    formData.append("type", "INDIA_BATTERY");

    const editor = quillRef.current?.getEditor();
    const html = editor?.root.innerHTML || "";
    formData.append("description", html);
    formData.append("meta_description", request.meta_description);
    formData.append("keywords", request.keywords);
    // 🔥 If editing, MUST send ID
    if (data?._id) {
      formData.append("id", data._id);
    }

    // 🔥 Logo send only if changed
    if (logo) {
      formData.append("logo", logo);
    }
    
    const validKeyAreas = keyAreas.filter(
     (item) => item.title && item.logo
    );
    formData.append("key_areas", JSON.stringify(validKeyAreas));


    //Trust areas
    const validTrustAreas = trustAreas.filter(
      (item) => item.title && item.logo
    );
    formData.append("trust_areas", JSON.stringify(validTrustAreas));

    //stackholders
    const validStackholders = stackholders.filter(
        (item) => item.title
    );
    formData.append("stackholders", JSON.stringify(validStackholders));
   
    //buttons
    const validButtons = buttons.filter(
     (b) => b.title && b.url
    );
    formData.append("buttons", JSON.stringify(validButtons));

    // 🔥 createdBy only on create
    if (!data?._id && userData?._id) {
      formData.append("createdBy", userData._id);
    }

    WebService.fileUploadAPI({
      action: `council/addContent`,
      body: formData,
    })
      .then((res: any) => {
        toast.success(res.message);
        setLoading(false);
        handleClose();
      })
      .catch((err: any) => {
        setLoading(false);
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];
  const uploadFile = (file: File, index: number, type: string) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("storage", "COUNCIL");
    WebService.fileUploadAPI({
      action: `upload`,
      body: formData,
    })
      .then((res: any) => {
        if (res.data) {
          if (type === "KEY_AREA") {
            keyAreas[index].logo = res.data?.url;
            setKeyAreas([...keyAreas]);
          }
          if (type === "TRUST_AREAS") {
            trustAreas[index].logo = res.data?.url;
            setTrustAreas([...trustAreas]);
          }
        }
        toast.success(res.message);
      })
      .catch((err: any) => {
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          handleClose();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{data ? "Edit" : "Add"}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Main Content
              </span>

              <Form.Group className="mb-2" controlId="title">
                <Form.Label className="label">Title<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter title"
                  {...register("title", { required: "Title is required" })}
                />
                {errors.title && (
                  <div className="error-message">{errors.title.message}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-2" controlId="slugField">
                <Form.Label className="label">Slug</Form.Label>{" "}
                <span className="text-danger">*</span>
                <Form.Control
                  type="text"
                  placeholder="Enter slug"
                  {...register("slug", {
    required: "Slug is required",
    // pattern: {
    //   value: /^[a-z0-9-]+$/,
    //   message:
    //     "Slug must be lowercase and can only contain letters, numbers, and hyphens",
    // },
  })}
                />
                {errors.slug && (
  <div className="error-message">{errors.slug.message}</div>
)}
              </Form.Group>

              <Form.Group className="mb-2" controlId="eventDescription">
                <Form.Label className="label">Description<span className="text-danger">*</span></Form.Label>

                <CommonQuill
                  ref={quillRef}
                  value={value}
                  onChange={setValue}
                  storage="COUNCIL"
                  initialHtml={show && data?.description ? HelperService.normalizeResizeHtml(data.description) : undefined}
                  onClearError={() =>
                    setCustomErrors((p) => ({
                      ...p,
                      description: undefined,
                    }))
                  }
                />
                {customErrors.description && (
                  <div className="error-message">
                    {customErrors.description}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="label">Buttons</Form.Label>

                {buttons.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("buttonIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("buttonIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...buttons];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setButtons(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-center mb-2">
                      {/* DRAG ICON */}
                      <span className="drag-icon">⋮⋮</span>

                      {/* TITLE */}
                      <Form.Control
                        placeholder="Button title"
                        value={item.title}
                        className="me-2"
                        onChange={(e) => {
                          const updated = [...buttons];
                          updated[index].title = e.target.value;
                          setButtons(updated);
                        }}
                      />

                      {/* URL */}
                      <Form.Control
                        placeholder="Button URL"
                        value={item.url}
                        className={`me-2 ${
                          urlErrors[index] ? "is-invalid" : ""
                        }`}
                        onChange={(e) => {
                          const value = e.target.value.trim();

                          const updated = [...buttons];
                          updated[index].url = value;
                          setButtons(updated);

                          // 🔍 INLINE URL VALIDATION
                          const isValid =
                            /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/.test(
                              value,
                            );

                          if (value && !isValid) {
                            setUrlErrors((prev) => ({
                              ...prev,
                              [index]:
                                "Enter a valid URL (https://example.com)",
                            }));
                          } else {
                            setUrlErrors((prev) => {
                              const copy = { ...prev };
                              delete copy[index];
                              return copy;
                            });
                          }
                        }}
                      />

                      {/* ❌ ERROR MESSAGE */}
                      {urlErrors[index] && (
                        <div className="invalid-feedback d-block">
                          {urlErrors[index]}
                        </div>
                      )}

                      {/* HIGHLIGHT */}
                      <Form.Check
                        type="checkbox"
                        label="Highlight"
                        checked={item.highlight}
                        className="me-2"
                        onChange={(e) => {
                          const updated = [...buttons];
                          updated[index].highlight = e.target.checked;
                          setButtons(updated);
                        }}
                      />

                      {/* ADD */}
                      <PlusSquareFill
                        size={35}
                        className="me-2 cursor-pointer"
                        onClick={() =>
                          setButtons([
                            ...buttons,
                            { title: "", url: "", highlight: false },
                          ])
                        }
                      />

                      {/* REMOVE */}
                      {buttons.length > 1 && (
                        <DashSquareFill
                          size={35}
                          className="cursor-pointer"
                          onClick={() =>
                            setButtons(buttons.filter((_, i) => i !== index))
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}
              </Form.Group>

              {/* <Form.Group className="mb-2" controlId="createdBy">
                <Form.Label className="label">Created By</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Created by user"
                  {...register("createdBy")}
                  value={watch("createdBy") || ""}
                  disabled
                />
              </Form.Group> */}
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Key Areas
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label">Key Areas</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>44 × 44 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {keyAreas.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("keyAreaIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("keyAreaIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...keyAreas];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setKeyAreas(updated);
                    }}
                    style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start mb-2">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }
                              setFileError("");
                              uploadFile(file, index, "KEY_AREA");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 120, marginTop: 5 }}
                            />
                          )}

                          <div className="d-flex mt-2">
                            <Form.Control
                              placeholder="Title"
                              value={item.title}
                              onChange={(e) => {
                                const updated = [...keyAreas];
                                updated[index].title = e.target.value;
                                setKeyAreas(updated);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() =>
                                setKeyAreas([
                                  ...keyAreas,
                                  { title: "", logo: "" },
                                ])
                              }
                            />

                            {keyAreas.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() =>
                                  setKeyAreas(
                                    keyAreas.filter((_, i) => i !== index),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Thrust Areas
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label">Thrust Areas</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>44 × 44 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {trustAreas.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("trustIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("trustIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...trustAreas];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setTrustAreas(updated);
                    }}
                  >
                    <div className="d-flex align-items-start mb-2">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }
                              setFileError("");
                              uploadFile(file, index, "TRUST_AREAS");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 120, marginTop: 5 }}
                            />
                          )}

                          <div className="d-flex mt-2">
                            <Form.Control
                              placeholder="Title"
                              value={item.title}
                              onChange={(e) => {
                                const updated = [...trustAreas];
                                updated[index].title = e.target.value;
                                setTrustAreas(updated);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() =>
                                setTrustAreas([
                                  ...trustAreas,
                                  { title: "", logo: "" },
                                ])
                              }
                            />

                            {trustAreas.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() =>
                                  setTrustAreas(
                                    trustAreas.filter((_, i) => i !== index),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Key Stackholders
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label">Stackholders</Form.Label>

                {stackholders.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("stackIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("stackIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...stackholders];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setStackholders(updated);
                    }}
                  >
                    <div className="d-flex align-items-center mb-2">
                      <span className="drag-icon">⋮⋮</span>

                      <Form.Control
                        placeholder="Stackholder title"
                        value={item.title}
                        onChange={(e) => {
                          const updated = [...stackholders];
                          updated[index].title = e.target.value;
                          setStackholders(updated);
                        }}
                      />

                      <PlusSquareFill
                        className="ms-2 cursor-pointer"
                        onClick={() =>
                          setStackholders([...stackholders, { title: "" }])
                        }
                      />

                      {stackholders.length > 1 && (
                        <DashSquareFill
                          className="ms-2 cursor-pointer"
                          onClick={() =>
                            setStackholders(
                              stackholders.filter((_, i) => i !== index),
                            )
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Media
              </span>
              <Form.Group className="mb-2" controlId="logo">
                <Form.Label className="label">Logo</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>228 × 91 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                <Form.Control
                  type="file"
                  accept="image/*"
                  className="custom-image-upload"
                  onChange={(e) => {
                    const input = e.target as HTMLInputElement;
                    const selectedFile = input.files?.[0];

                    if (!selectedFile) return;

                    if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                      setFileError(
                        "Image format not supported. Please upload PNG, JPG, JPEG or SVG. image",
                      );
                      // console.log(fileError)
                      //      toast.error(fileError);
                      setLogo(null);
                      input.value = ""; // reset input
                      return;
                    }

                    // ✅ valid
                    setFileError("");
                    setLogo(selectedFile);
                  }}
                />
              </Form.Group>
              {(logo || data?.logo) && (
                <div className="mb-2 event-image">
                  <img
                    src={logo ? URL.createObjectURL(logo) : data?.logo}
                    alt="Event"
                    style={{
                      maxWidth: "100%",
                      maxHeight: 200,
                      objectFit: "contain",
                      marginTop: "5px",
                    }}
                  />
                </div>
              )}
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                SEO
              </span>
              <Form.Label className="label">
                Meta Description
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Meta Description"
                {...register("meta_description", {
                  required: "Meta description is required",
                })}
              />
              {errors.meta_description && (
                <div className="error-message">
                  {errors.meta_description.message}
                </div>
              )}
              <Form.Group className="mb-2" controlId="eventName">
                <Form.Label className="label">
                  Keywords <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter keywords"
                  {...register("keywords", {
                    required: "Keywords are required",
                  })}
                />
                {errors.keywords && (
                  <div className="error-message">{errors.keywords.message}</div>
                )}
              </Form.Group>
            </Card>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddIndiaBatteryManufacturing;
